module.exports = __webpack_public_path__ + "3ce3c015f060d7b03cdcf6078af332ce.png";